// extracted by mini-css-extract-plugin
module.exports = {"title":"page_title__eMbc0","container":"page_container__2mtUC","alert":"page_alert__2f1cB","pageContainer":"page_pageContainer__3Ecvg"};